'use strict';

// Constructor
var SideNavigation = function () {
    // We use js to only show the relevant menu parents and children on desktop
    // On mobile we clone the menu in a different container

    // Add a skip link to skip the side nav
    $('.spf-side-nav').before('<a href="#main-content" class="visually-hidden focusable skip-link">Skip to main content</a>');

    // If there an active trail then hide the rest and make the active trail parent
    if ($('.spf-side-nav .menu-item--active-trail').length > 0) {
        $('.spf-side-nav').addClass('has-active-trail');
    } else {
        $('.spf-side-nav').addClass('no-active-trail');
    }

    // Add the link used to expand menu for parent LI
//    $('.spf-side-nav .menu-item--expanded > a').after('<a class="expand" aria-expanded="false" aria-label="Toggle sub-navigation" href="#expand"><i class="fa fa-chevron-down"></i></a>');
    $('.spf-page-sidebar--left .spf-side-nav .menu-item--expanded > a')
        .before('<button class="expand" aria-expanded="false" aria-label="Toggle sub-navigation" ><i class="fa fa-chevron-down"></i></button>')
        .next().hide();
    // Generic accordion trigger to expand the immediate child UL after it
    $('body').on('click', '.expand', function ($event) {
        $event.preventDefault();
        $('.expand').attr('aria-expanded', 'false');

        if ($(this).hasClass('active')) {
            $(this).siblings('ul').hide();
            $(this).siblings('.level-1').hide();
            $(this).removeClass('active');
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).addClass('active');
            $(this).siblings('ul').show();
            $(this).siblings('.level-1').show();
            $(this).attr('aria-expanded', 'true');
        }
    });

    // For the active link show all the parents and immediate child
    $('.spf-side-nav a.is-active').parents('ul').show();
    $('.spf-side-nav a.is-active').parents('ul').siblings('.expand').addClass('active').attr('aria-expanded', 'true');
    $('.spf-side-nav a.is-active').siblings('ul').show();
    $('.spf-side-nav a.is-active').siblings('.expand').addClass('active').attr('aria-expanded', 'true');

    // Inject the mobile menu button
    $('.uikit-header.uikit-header--light').append('<button aria-label="Open Menu"  aria-expanded="false" title="Open menu" class="mobile-menu-button" ><i class="fa fa-bars open"></i> <i class="fa fa-times close"></i></button>');

    // Inject the mobile menu container
    $('body').append('<div class="mobile-menu-overlay"></div>');
    // $('body').append('<div class="mobile-menu"></div>');

    // Bind the click action to open close menu
    $('.mobile-menu-button, .mobile-menu-overlay').click(function ($event) {
        $event.preventDefault();
        $('.mobile-menu-button').toggleClass('active');
        $('#block-mobile-navigation').toggleClass('active');
        $('.mobile-menu-overlay').toggleClass('active');

        $('.mobile-menu-button').hasClass('active') ? $('.mobile-menu-button').attr('aria-expanded', 'true') : $('.mobile-menu-button').attr('aria-expanded', 'false');
    });


    // Clone the menu markup in the mobile menu container
    // if ($('.spf-side-nav').length > 0) {
    //     // If there is a side naviagtion
    //     $('#block-mobile-navigation').html('<ul>' + $('.spf-side-nav').html() + '</ul>');
    // } else {
    //     // If not side navigation take the main menu
    //     $('#block-mobile-navigation').html('<ul class="simple">' + $('#block-act-health-public-website-main-menu .spf-top-nav ul').html() + '</ul>');
    // }

    // Add the link used to expand menu for parent LI
    $('#block-mobile-navigation .menu-item--expanded').each(function () {
        // Check if there is sub menu items
        if ($(this).find('ul').length > 0) {
            $(this).prepend('<a class="expand" href="#expand"><i class="fa fa-chevron-down"></i></a>');
        }
    });


    // On the mobile menu the active link show all the parents and immediate child
    // $('#block-mobile-navigation .menu-item--expanded').parents('ul')
    // $('#block-mobile-navigation .menu-item--expanded').parents('.level-1').show();
    //$('#block-mobile-navigation .menu-item--expanded').parents('ul').siblings('.expand');
    $('#block-mobile-navigation .menu-item--expanded').parents('ul').siblings('.expand').attr('aria-expanded', 'false');
    // $('#block-mobile-navigation .menu-item--expanded').siblings('ul').show();
    // $('#block-mobile-navigation .menu-item--expanded').siblings('.level-1').show();
    // $('#block-mobile-navigation .menu-item--expanded').siblings('.expand').addClass('active');

    // Add a close button to close the slide out menu
    $('#block-mobile-navigation').prepend('<a href="#" class="close-mobile-menu" aria-label="Close menu" alt="close menu"><i class="fa fa-times"></i></a>');

    // Bind the close menu action
    $('.close-mobile-menu').click(function ($event) {
        $event.preventDefault();
        $('.mobile-menu-button').toggleClass('active');
        $('#block-mobile-navigation').toggleClass('active');
        $('.mobile-menu-overlay').toggleClass('active');
    });

    //add title to elements for accessibility
    $(".menu-item--expanded .expand").attr("title", "Expand menu");
};

module.exports = SideNavigation;
